var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cm-title"},[_c('span',{style:({ fontSize: _vm.fontSize + 'px' }),domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }